
import Vue from "vue";
import { getVisiblePages } from "@/utils/pagination";

export default Vue.extend({
  name: "PaginationBar",
  props: {
    value: { type: Number, required: true },
    totalPage: { type: Number, required: true },
    siblingCount: { type: Number, default: 1 },
    maxAll: { type: Number, default: 9 },
  },
  computed: {
    items() {
      return getVisiblePages(this.value, this.totalPage, {
        siblingCount: this.siblingCount,
        maxAll: this.maxAll,
      });
    },
  },
  methods: {
    go(p: number) {
      if (p !== this.value) this.$emit("input", p);
    },
    goPrev() {
      if (this.value > 1) this.$emit("input", this.value - 1);
    },
    goNext() {
      if (this.value < this.totalPage) this.$emit("input", this.value + 1);
    },
  },
});
